export const SET_TITLE = 'SET_TITLE';
export const RESET_TITLE = 'RESET_TITLE';
export const UPDATE_ACTION_TIME = 'UPDATE_ACTION_TIME';
export const RESET_SESSION = 'RESET_SESSION';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';

export function setTitle(title) {
	return {
		type: SET_TITLE,
		title
	};
}

export function resetTitle() {
	return {
		type: RESET_TITLE
	};
}

export function updateLastActionTime() {
	return {
		type: UPDATE_ACTION_TIME
	};
}

export function resetSession() {
	return {
		type: RESET_SESSION
	};
}

export function setSessionExpired() {
	return {
		type: SESSION_EXPIRED
	};
}



// WEBPACK FOOTER //
// ./src/client/redux/actions/page.js